(function() { module.exports = window["wp"]["plugins"]; }());